module.exports = require("script-ext-html-webpack-plugin");


//////////////////
// WEBPACK FOOTER
// external "script-ext-html-webpack-plugin"
// module id = 47
// module chunks = 0